export default __webpack_public_path__ + "static/media/formLevelUpIcon.4eba8282.svg";